module.exports = __webpack_public_path__ + "img/bg-2.7f144466.jpg";